import { render } from "./FeeSetting.vue?vue&type=template&id=1cdcfbcf&ts=true"
import script from "./FeeSetting.vue?vue&type=script&lang=ts"
export * from "./FeeSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__